import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash';

import EditSelectedFoodItemsComponent from 'PointOfSale/modules/individualServing/component/EditSelectedFoodItems';
import {
  setSearchText,
  selectTabMenu,
  reset,
  selectFoodItem,
  saveOrderNum,
} from 'PointOfSale/modules/mealTypes/state/actions';
import { getValue } from 'Common/Components/Keyboard/withKeyboard';
import * as POSSelectors from 'PointOfSale/selectors';

class EditSelectedFoodItems extends Component {
  tabClickHandler = tab => {
    this.props.selectTabMenu(tab);
  };
  searchHandler = e => {
    const searchText = getValue(e);
    this.props.setSearchText(searchText);
  };

  get items() {
    const {
      currentSelectedMenu,
      currentSelectedTabMenu,
      filteredAllFoodItems,
    } = this.props;

    const items = get(
      filteredAllFoodItems,
      [currentSelectedMenu, currentSelectedTabMenu],
      []
    );
    return items;
  }

  areAllItemsSelected = () => {
    return this.items.length > 0 && this.items.every(i => i.selected);
  };

  areNoItemsSelected = () => {
    return this.items.length === 0 || this.items.every(i => !i.selected);
  };

  toggleSelectedItems = selected => {
    this.items.forEach(item => this.props.selectFoodItem(item, selected));
  };

  save = () => {
    this.props.saveOrderNum();
  };

  render() {
    const {
      tabMenus,
      searchText,
      onModalToggle,
      open,
      saveOrderNumFetching,
    } = this.props;
    return (
      <EditSelectedFoodItemsComponent
        onClose={onModalToggle}
        open={open}
        tabMenus={tabMenus}
        tabClickHandler={this.tabClickHandler}
        searchText={searchText}
        searchHandler={this.searchHandler}
        reset={this.reset}
        toggleSelectedItems={this.toggleSelectedItems}
        allItemsSelected={this.areAllItemsSelected()}
        noItemsSelected={this.areNoItemsSelected()}
        save={this.save}
        saving={saveOrderNumFetching}
      />
    );
  }
}

EditSelectedFoodItems.propTypes = {
  mealTypes: PropTypes.object,
  currentSelectedMenu: PropTypes.string,
  setSearchText: PropTypes.func,
  selectTabMenu: PropTypes.func,
  reset: PropTypes.func,
  selectFoodItem: PropTypes.func,
};

const mapStateToProps = state => ({
  filteredAllFoodItems: POSSelectors.filteredAllFoodItems(state),
  foodItems: POSSelectors.getFoodItems(state),
  tabMenus: POSSelectors.getSelectedMealTypesTabsMenus(state),
  currentSelectedMenu: POSSelectors.getCurrentSelectedMenu(state),
  currentSelectedTabMenu: POSSelectors.getCurrentSelectedTabMenu(state),
  searchText: POSSelectors.getMealTypesSearchText(state),
  saveOrderNumFetching: POSSelectors.getSaveOrderNumFetching(state),
});

const mapDispatchToProps = {
  setSearchText,
  selectTabMenu,
  reset,
  selectFoodItem,
  saveOrderNum,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditSelectedFoodItems)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/container/EditSelectedFoodItems.js